const config = {
  LANG: 'en', // 语言设置默认为英语
  locales: {
    'en': {
      months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    },
  }, // 语言包
};

function $addZero(v, size) {
  for (let i = 0, len = size - (v + '').length; i < len; i++) {
    v = '0' + v;
  }
  return v + '';
}

function format(date, formatStr) {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  if (window?.isNaN?.(date.getTime())) {
    return 'Invalid date';
  }

  const { locales, LANG } = config;

  // 格式化时间
  const arrWeek = locales[LANG].weekdaysMin;
  const arrMonthShort = typeof locales[LANG].monthsShort === 'function' ? locales[LANG].monthsShort() : locales[LANG].monthsShort;
  const arrMonth = typeof locales[LANG].months === 'function' ? locales[LANG].months() : locales[LANG].months;
  let meridiem = locales[LANG].meridiem;
  const postFormat = locales[LANG].postformat;
  if (!meridiem) {
    meridiem = function (hours, minutes, isLower) {
      if (hours >= 12) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    };
  }

  let hours = date.getHours();
  if (hours === 0) { // 0点的情况处理为 12:00 AM
    hours = 12;
  } else if (hours > 12) {
    hours -= 12;
  }

  const str = formatStr
    .replace(/yyyy|YYYY/, date.getFullYear())
    .replace(/yy|YY/, $addZero(date.getFullYear() % 100, 2))
    .replace(/dd|DD/, $addZero(date.getDate(), 2))
    .replace(/d|D/g, date.getDate())
    .replace(/hh/, $addZero(hours, 2))
    .replace(/HH/, $addZero(date.getHours(), 2))
    .replace(/h/g, hours)
    .replace(/H/g, date.getHours())
    .replace(/ii|II/, $addZero(date.getMinutes(), 2))
    .replace(/i|I/g, date.getMinutes())
    .replace(/ss|SS/, $addZero(date.getSeconds(), 2))
    .replace(/s|S/g, date.getSeconds())
    .replace(/w/g, date.getDay())
    .replace(/W/g, arrWeek[date.getDay()])
    .replace(/\b(mmmm|MMMM)\b/, arrMonth[date.getMonth()])
    .replace(/\b(mmm|MMM)\b/, arrMonthShort[date.getMonth()])
    .replace(/\b(mm|MM)\b/, $addZero(date.getMonth() + 1, 2))
    .replace(/\b(m|M)\b/g, date.getMonth() + 1)
    .replace(/\ba\b/g, meridiem(date.getHours(), date.getMinutes(), true))
    .replace(/\bA\b/g, meridiem(date.getHours(), date.getMinutes(), false));
  return postFormat ? postFormat(str) : str;
}

function toObject(date) {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  return {
    years: date.getFullYear(),
    months: date.getMonth(),
    date: date.getDate(),
    hours: date.getHours(),
    minutes: date.getMinutes(),
    seconds: date.getSeconds(),
    milliseconds: date.getMilliseconds(),
  };
}

function getDuration(ts) { // ts单位秒
  // 根据时间差计算剩余的时间，返回[天，小时，分，秒]
  const timeLeft = [0, 0, 0, 0]; // 结构：天、小时、分、秒
  timeLeft[0] = (ts > 86400) ? parseInt(ts / 86400) : 0;
  ts = ts - timeLeft[0] * 86400;
  timeLeft[1] = (ts > 3600) ? parseInt(ts / 3600) : 0;
  ts = ts - timeLeft[1] * 3600;
  timeLeft[2] = (ts > 60) ? parseInt(ts / 60) : 0;
  timeLeft[3] = ts - timeLeft[2] * 60;
  return timeLeft;
}

function setLocale(LANG) {
  for (const key in config.locales) {
    if (key === LANG) {
      config.LANG = LANG;
      break;
    }
  }
}

function defineLocale(name, opts) {
  if (!config.locales[name]) {
    config.locales[name] = opts;
  }
}

function getLocales() {
  const arr = [];
  for (const key in config.locales) {
    if (key) {
      arr.push(key);
    }
  }
  return arr;
}

function getConfig() {
  return config;
}

function isToday(time) {
  const comparisonTemplate = 'YYYY-MM-DD';
  const now = Date.now();

  return format(time, comparisonTemplate) === format(now, comparisonTemplate);
}

export default {
  setLocale,
  format,
  toObject,
  defineLocale,
  getLocales,
  getConfig,
  getDuration,
  isToday
};
